import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { ActiveLens, ClearedLens, LoadedLens, LoadingLens } from '@infl-ts/util-lens';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BlockIcon from '@mui/icons-material/Block';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, CircularProgress, css, styled, Typography, useMediaQuery } from '@mui/material';
import { absurd } from 'fp-ts/function';
import { useState } from 'react';
import ClearModal from './clear-modal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledButton = styled(Button)(function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    margin-left: ", ";\n    padding: ", ";\n    height: 40px;\n    min-width: 100px;\n    width: 100px;\n    text-transform: none;\n    ", " {\n      min-width: 40px;\n      width: 40px;\n    }\n  "])), theme.palette.primary.contrastText, theme.spacing(1), theme.spacing(1), theme.breakpoints.down('md'));
});
var StyledLoader = styled(CircularProgress)(function (_ref2) {
  var theme = _ref2.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    color: inherit;\n    margin-right: ", ";\n    ", " {\n      margin-right: 0;\n    }\n  "])), theme.spacing(0.5), theme.breakpoints.down('md'));
});

var Action = function Action(_ref3) {
  var text = _ref3.text,
      action = _ref3.action,
      icon = _ref3.icon,
      lensActionPending = _ref3.lensActionPending;
  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  return /*#__PURE__*/_jsxs(StyledButton, {
    variant: "contained",
    size: "small",
    onClick: action,
    "data-element": "StyledButton",
    "data-component": "Action",
    "data-source-file": "action-button.tsx",
    children: [lensActionPending && /*#__PURE__*/_jsx(StyledLoader, {
      size: isMobile ? 20 : 12
    }), isMobile ? !lensActionPending && icon : /*#__PURE__*/_jsx(Typography, {
      variant: "body2",
      children: text
    })]
  });
};

var ActionButton = function ActionButton(_ref4) {
  var lens = _ref4.lens,
      lensActionPending = _ref4.lensActionPending,
      _ref4$actions = _ref4.actions,
      cancelLens = _ref4$actions.cancelLens,
      clearLens = _ref4$actions.clearLens,
      loadLens = _ref4$actions.loadLens;

  var _useState = useState(false),
      modalOpen = _useState[0],
      setModalOpen = _useState[1];

  if (ClearedLens.is(lens)) {
    return /*#__PURE__*/_jsx(Action, {
      text: "Load Lens",
      action: loadLens,
      icon: /*#__PURE__*/_jsx(ArrowForwardIcon, {}),
      lensActionPending: lensActionPending
    });
  }

  if (LoadingLens.is(lens)) {
    return /*#__PURE__*/_jsx(Action, {
      text: lensActionPending ? 'Cancelling...' : 'Cancel',
      action: cancelLens,
      icon: /*#__PURE__*/_jsx(BlockIcon, {}),
      lensActionPending: lensActionPending
    });
  }

  if (LoadedLens.is(lens)) {
    return /*#__PURE__*/_jsx(Action, {
      text: lensActionPending ? 'Clearing...' : 'Clear Lens',
      action: clearLens,
      icon: /*#__PURE__*/_jsx(CancelIcon, {}),
      lensActionPending: lensActionPending
    });
  }

  if (ActiveLens.is(lens)) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Action, {
        text: lensActionPending ? 'Clearing...' : 'Clear Lens',
        action: function action() {
          return setModalOpen(true);
        },
        icon: /*#__PURE__*/_jsx(CancelIcon, {}),
        lensActionPending: lensActionPending
      }), /*#__PURE__*/_jsx(ClearModal, {
        open: modalOpen,
        handleClose: function handleClose() {
          return setModalOpen(false);
        },
        clearLens: clearLens
      })]
    });
  }

  return absurd(lens);
};

export default ActionButton;